module.exports = __webpack_public_path__ + "static/media/information.0108b914.svg";